import { mealOptions } from "@/app/nutrition/meal";
import { NutritionSearchValues } from "@/app/nutrition/search.schema";
import { t } from "i18next";
import React, { ChangeEventHandler, Fragment, type FC } from "react";
import { Select } from "./Select";
import { InputWithCornerHint } from "../atoms/InputWithCornerHint";
import { DishListItem } from "./ListFoods";
import { Meal } from "@/app/nutrition/meal.enum";
import PaginationUI from "../atoms/PaginationUI";

export type SearchDishesProps = {
  onlySelect?: boolean;
  currentPage: number;
  dishes: Array<any>;
  isLoading?: boolean;
  lastPage: number;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onPageChange: (page: number) => void;
  onSetDish: (dish: any, meal: Meal) => void;
  perPage: number;
  setFieldValue: (field: string, value: any) => void;
  total: number;
  values: NutritionSearchValues;
};

export const SearchDishes: FC<SearchDishesProps> = ({
  currentPage,
  dishes,
  isLoading,
  lastPage,
  onChange,
  onPageChange,
  onSetDish,
  perPage,
  setFieldValue,
  total,
  values,
  onlySelect,
}) => {
  return (
    <div className="flex flex-col flex-grow">
      <div className="flex flex-col">
        <div className="col-span-full mx-4 mt-2">
          <Select
            name="meal"
            selected={mealOptions.find((option) => option.id == values.meal)}
            setSelected={(option) => setFieldValue("meal", option.id)}
            options={mealOptions}
            tittle={t("accounting.views.type")}
          />
        </div>
        <div className="col-span-full mx-4 mt-2">
          <InputWithCornerHint
            label={t("general.search")}
            placeholder={t("user.views.name_food")}
            type="text"
            onChange={onChange}
            name="dishes"
            value={values.dishes}
          />
        </div>
        <div className="col-span-full">
          <h1 className="text-base font-semibold leading-6 text-gray-900 border-b border-gray-200 text-center pb-3 mt-4">
            {t("nutrition-wizard.views.meals")}
          </h1>
        </div>
      </div>
      <div className="flex-grow flex flex-col h-20 overflow-y-scroll">
        <div className="grid gap-4 grid-cols-1 2xl:grid-cols-2 overflow-y-auto p-4">
          {isLoading ? (
            <Fragment>
              <DishListItem isLoading />
              <DishListItem isLoading />
              <DishListItem isLoading />
              <DishListItem isLoading />
              <DishListItem isLoading />
            </Fragment>
          ) : (
            <Fragment>
              {dishes.map((dish) => (
                <DishListItem
                  key={dish.id}
                  dish={dish}
                  onSetDish={onSetDish}
                  onlySelect={onlySelect}
                />
              ))}
            </Fragment>
          )}
        </div>
      </div>
      <div className="flex flex-col flex-shrink-0 flex-grow-0 bg-green-100">
        <PaginationUI
          onPageChange={onPageChange}
          currentPage={currentPage}
          totalPages={lastPage}
          pageSize={perPage}
          totalResults={total}
        />
      </div>
    </div>
  );
};
